// ----------------------------------------------------------------------------
// Section: What's Inside
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_what-inside.scss';


import $ from 'jquery';
import Swiper, { Navigation, FreeMode, Thumbs, Keyboard } from 'swiper/core';

// // Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/keyboard';

const selectors = {
    productThumbnailsSlider: 'carousel--accordion-product-thumbnails',
    productFeatureSlider: 'carousel--featured-accordion-product',
};

const slideToSlide = (slider, slideIndex, transition) => {
    if (transition) {
        slider.slideTo(slideIndex);
    } else {
        slider.slideTo(slideIndex, 0);
    }
}

$(function() {
    $(`.${selectors.productThumbnailsSlider}`).each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("accordion-product-carousel-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.accordion-product__thumbnail-wrapper').find(".swiper-button-prev-product").addClass("accordion-product-carousel-btn-prev-" + index);
        $this.parents('.accordion-product__thumbnail-wrapper').find(".swiper-button-next-product").addClass("accordion-product-carousel-btn-next-" + index);

        var accordionProductThumbnailSwiper = new Swiper(".accordion-product-carousel-instance-" + index, {
            // Optional parameters
            modules: [Navigation, FreeMode, Keyboard],
            slidesPerView: 4, // If you change this number, update it in liquid too
            freeMode: true,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            navigation: true,
            spaceBetween: 3,

            keyboard: {
                enabled: false
            },
            a11y: false,
            breakpoints: {
                // when window width is >= 680px
                680: {
                    direction: "vertical",
                    spaceBetween: 10
                }
            },
            multipleActiveThumbs: false
        });

        var accordionProductFeaturedImage = $this.parents('.js-accordion__item').find(`.${selectors.productFeatureSlider}`);

        accordionProductFeaturedImage.addClass(`accordion-product-featured-image-instance-${index}`);

        var accordionProductFeaturedImageSwiper = new Swiper(`.accordion-product-featured-image-instance-${index}`, {
            // Optional parameters
            modules: [Navigation, Thumbs],
            spaceBetween: 0,

            // Navigation arrows
            navigation: {
                nextEl: ".accordion-product-carousel-btn-next-" + index,
                prevEl: ".accordion-product-carousel-btn-prev-" + index
            },

            thumbs: {
              swiper: accordionProductThumbnailSwiper,
            }
        });

        $(accordionProductThumbnailSwiper.slides).each(function(index, slide) {
            $(slide).on('focus', function(e) {
                let slideIndex = slide.getAttribute('data-index');
                slideToSlide(accordionProductThumbnailSwiper, slideIndex, true);
                slideToSlide(accordionProductFeaturedImageSwiper, slideIndex, true);
                $(accordionProductThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                    $(thumbnailSlide).attr('tabindex', '0');
                })
            })
            $(slide).on('keydown', function(e) {
                if (e.key === "Enter") {
                    $(accordionProductThumbnailSwiper.slides).each(function(i, thumbnailSlide) {
                        $(thumbnailSlide).attr('tabindex', '-1');
                    })
                    $(slide).attr('tabindex', '0');
                    let slideIndex = parseInt(slide.getAttribute('data-index'));
                    accordionProductFeaturedImageSwiper.slides[slideIndex].focus();
                }
            })
        });
    });
});
